module.exports = __webpack_public_path__ + "f4ce5a4f9e97a38af377704aa57c3e9d.pdf";